export const SET_LOADING = 'src/store/zoneManagement/SET_LOADING'
export const SET_SAVE_LOADING = 'src/store/zoneManagement/SET_SAVE_LOADING'
export const SET_MATCH_TICKET = 'src/store/zoneManagement/SET_MATCH_TICKET'
export const SET_SUBZONE = 'src/store/zoneManagement/SET_SUBZONE'
export const SET_SEAT = 'src/store/zoneManagement/SET_SEAT'
export const SET_TICKET_RESPONSE = 'src/store/zoneManagement/SET_TICKET_RESPONSE'
export const SET_TICKET_DOWNLOAD = 'src/store/zoneManagement/SET_TICKET_DOWNLOAD'

